require.register("app/restaurant/stat/SupplierCARankView", function(exports, require, module){
  $0
  
});

